import classNames from "classnames";
import React from "react";
import BasicText from "../BasicText/BasicText";

const TitleSecondary = ({ children, className }) => (
  <BasicText className={classNames("fs-12", className)}>{children}</BasicText>
);

export default TitleSecondary;
